import {
  Country,
  GetExcursionCalendarResponse,
  GetExcursionSearchOptionsResponse,
  SearchOnlyExcursionPackagesRequest,
  SearchOnlyExcursionPackagesResponse
} from '@appTypes/api.types';
import { DataLoadStatusModel, RequestStateModel, StateFormModel } from '@core/store/store.models';

/** 27.09.2026: one month of the excursions calendar for one parameter set (country, cities, categories, party, year, month) */
export class ExcursionsCalendarModel {
  data = new RequestStateModel<GetExcursionCalendarResponse>();
  identifier!: string;
}

export class ExcursionsPageDataModel {
  destinationCountries = new RequestStateModel<Country[]>();
  destinationDefaultCountry: string | null = null;
  /** the cities and categories with excursions on sale in the chosen country (25.09.2026) */
  searchOptions = new RequestStateModel<GetExcursionSearchOptionsResponse>();
  searchOptionsCountry: string | null = null;
  /** the months of the calendar read so far, by parameter set (27.09.2026) */
  calendars: ExcursionsCalendarModel[] = [];
}

export class ExcursionsStateModel {
  searchForm = new StateFormModel<SearchOnlyExcursionPackagesRequest>();
  searchLoadStatus = new DataLoadStatusModel();
  searchResults = new RequestStateModel<SearchOnlyExcursionPackagesResponse>();
  /** the kinds ticked in the Availability list; empty = every kind */
  kindsFilter: string[] = [];
  /** the criteria of the last search that found nothing - the empty-result message reads the calendar of that month (27.09.2026); null after a search that found packages or failed */
  lastSearch: SearchOnlyExcursionPackagesRequest | null = null;
  pageData = new ExcursionsPageDataModel();
}
